import React, { Component } from 'react';
import constant from '../../constant';
import { getCookie, getStorage } from '../../utils';
import CommentModel from './CommentModel';
import MedicalCommentModel from './EditMoule/MedicalCommentModel';

export default class AddMedicalComment extends Component {
   constructor(props){
    super(props)
     this.state = {
      ud :getCookie(constant.cookie.userDetail) , 
      hrExecutive :getStorage(constant.cookie.hrexecutive)[0] , 
      hrDealingOfficer:getStorage(constant.cookie.hrDealingOfficerList)[0] 
     }
   }
   
  render() {
     const {medicalData } = this.props
      const {ud , hrDealingOfficer ,hrExecutive } = this.state 
  
    return (
      <React.Fragment>
      <div className="container">
       
      {
        medicalData && medicalData.length>0 && ud.code==hrDealingOfficer.code ? 
             <CommentModel list={medicalData} redirect={this.props.redirect}   /> 
        : 

        medicalData && medicalData.length>0 && ud.code==hrExecutive.code ?
        <CommentModel list={medicalData} redirect={this.props.redirect}  /> : 
        // for finance files  
         
         <MedicalCommentModel list={medicalData}  redirect={this.props.redirect} />
    
      }
       
        
    </div>
        
      </React.Fragment>
    );  
  }
}
